var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"actionBar":true}},[_c('horse-add-details',{staticClass:"row mx-0 show active",attrs:{"slot":"tabContent","edit":_vm.edit,"register":_vm.register,"horseRegistrants":_vm.horseRegistrants},slot:"tabContent"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06c1a569","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Horses/Add/HorseAdd.vue
// module id = 913
// module chunks = 30